import type { Tour } from '@/config/objects/tours';
import { createEntityApi } from '@startupquickstart/frontend';

const toursApi = createEntityApi<Tour>({ resource: 'tours', queryKey: 'Tour' });

export const useTour = toursApi.useOne;
export const useTours = toursApi.useMany;
export const useCreateTour = toursApi.useCreate;
export const useUpdateTour = toursApi.useUpdate;
export const useDeleteTour = toursApi.useDelete;
